var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 1162,
    viewBox: "0 0 720 1162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -53.3663,
    cy: 428.635,
    rx: 265.634,
    ry: 354.811,
    fill: "#1B59F8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 453.423,
    ry: 556.863,
    transform: "matrix(0.707107 0.707107 -0.737781 0.67504 303.536 873.109)",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 218.208,
    ry: 326.793,
    transform: "matrix(0.881813 -0.471599 0.542268 0.840205 613.432 665.836)",
    fill: "#551BFA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.807,
    cy: 201.609,
    rx: 273.223,
    ry: 210.609,
    fill: "#1B59F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: -819,
    y: -509,
    width: 2194.02,
    height: 2376.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    colorInterpolationFilters: "sRGB",
    stdDeviation: 250,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 453.423,
    y1: 0,
    x2: 453.423,
    y2: 1113.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3177FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.2271d076b7625874ed748a676b5ece32.svg";
export { ForwardRef as ReactComponent };